import Submit from './Submit';
import Details from './Details';
import './Submissions.css';

export default function Details_Submit({
   homeworkID,
   onCancelCallback,
   onSubmitCallback,
   canSubmit,
   returned,
   remarks,
   submitRef,
}) {

   return (
      <div className="homework-details-submit-shell homework-stacked-details-submit-shell">
         <section className="homework-details-submit-panel">
               <Details
                  homeworkID={homeworkID}
               />
         </section>
         <section className="homework-details-submit-panel homework-submit-panel">
               <Submit
                  ref={submitRef}
                  homeworkID={homeworkID}
                  onCancelCallback={onCancelCallback}
                  onSubmitCallback={onSubmitCallback}
                  canSubmit={canSubmit}
                  returned={returned}
                  remarks={remarks}
                  showInlineActions={false}
               />
         </section>
      </div>
   );
}

